import { ExtendedEventBaseItem } from "./extended-event-base.item";
import { WaHelperService } from '../../wa-services/wa-helper-service';
import { SeriesAmateursItem } from "./series-amateurs-item";

export class SeriesAmateursRankingsItems extends ExtendedEventBaseItem {

  items:Array<SeriesAmateursItem>
  constructor(SeriesAmateursRankingsItemsraw: any, waHelperService:WaHelperService ) {
    super(SeriesAmateursRankingsItemsraw, waHelperService);
    this.items=SeriesAmateursRankingsItemsraw.items;
    //No sé si llamar a los métodos de la factoría desde aquí.

  }
}
